import { render, staticRenderFns } from "./ListadoAbogados.vue?vue&type=template&id=1a08be10&scoped=true"
import script from "./ListadoAbogados.vue?vue&type=script&lang=js"
export * from "./ListadoAbogados.vue?vue&type=script&lang=js"
import style0 from "./ListadoAbogados.vue?vue&type=style&index=0&id=1a08be10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a08be10",
  null
  
)

export default component.exports